function Animations(options) {
    this.defaults = {};
    $.extend(this.defaults, options);
}

Animations.prototype.preloader = function() {
    var self = this;
    self.animations = [];
};

Animations.prototype.init = function() {
    var self = this;
    this.hoverAnimations();
};

Animations.prototype.hoverAnimations = function() {
    var self = this;
    // animacja menu strefa turysty
    $('body.-tourist .menu-overlay-wrapper .menu-overlay-items__item a').each(function() {
        mySplitText = new SplitText($(this).find('> div'), {
            type: "words, chars"
        });
        if (mySplitText.chars.length > 0) {
            let t1 = gsap.timeline({paused: true});
            t1.fromTo(mySplitText.chars, {
                translateY: '0%',
            }, {
                duration: 0.4,
                opacity: 1,
                translateY: '-100%',
                transformOrigin: "0% 50%",
                ease: "power3.inOut",
                delay: 0,
                stagger: 0.012,
            });
            $(this).data('t1', t1);
        }
        $(this).on('mouseenter', function() {
            if (app.mq > 4 && $(this).data('t1'))
                $(this).data('t1').play();
        });
        $(this).on('mouseleave', function() {
            if (app.mq > 4 && $(this).data('t1'))
                $(this).data('t1').reverse();
        });
    });
};